// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__194r9","field":"styles_field__3QexX","fieldCol":"styles_fieldCol__3lre-","diffCol":"styles_diffCol__2ltjK","diff":"styles_diff__2hf9Q"};